import { formatNumber, parseNum } from "./util"

const cryptoPrices = async () => {
    const cryptos = [
        {symbol: "BTC", name: 'Bitcoin', id: 'bitcoin'},
        {symbol: "ETH", name: 'Ethereum', id: 'ethereum'},
        {symbol: "XRP", name: 'Ripple', id: 'ripple'},
        {symbol: "BNB", name: 'Binance Coin', id: 'binancecoin'},
        {symbol: "SOL", name: 'Solana', id: 'solana'},
        {symbol: "DOGE", name: 'Doge', id: 'doge'},
        {symbol: "ADA", name: 'Cardano', id: 'cardano'},
        {symbol: "STETH", name: 'Staked Ethereum', id: 'staked-ether'},
        {symbol: "TRX", name: 'Tron', id: 'tron'},
        {symbol: "AVAX", name: 'Avalanche', id: 'avalanche-2'},
        {symbol: "SUI", name: 'Sui', id: 'sui'}
    ]
    const MAX_DATE_DIFF = 1000 * 60 * 10
    const localPriceData = JSON.parse(window.localStorage.getItem("priceData"))
    const localUpToData = localPriceData && cryptos.every((crypto) => crypto.id in localPriceData.prices) && Date.now() - localPriceData.fetchedAt < MAX_DATE_DIFF
    let totalPriceData
    if (localUpToData) {
        totalPriceData = localPriceData.prices
    } else {
        try {
            const res = await fetch(`https://api.coingecko.com/api/v3/simple/price?ids=${cryptos.map((str) => str.id).join(',')}&vs_currencies=usd&include_24hr_change=true`)
            if (!res.ok) throw new Error(res.status)
            totalPriceData = await res.json()
            window.localStorage.setItem("priceData", JSON.stringify({
                prices: totalPriceData,
                fetchedAt: Date.now()
            }))
        } catch {
            // Fetch failed — fall back to stale cache if available
            if (localPriceData?.prices) {
                totalPriceData = localPriceData.prices
            } else {
                // No data at all — hide marquee and bail
                document.querySelectorAll(".crypto-marquee").forEach((el) => el.style.display = "none")
                return
            }
        }
    }

    const containers = document.querySelectorAll("[data-crypto-price-container]")
    containers.forEach((container) => {
        const templateQuery = container.getAttribute("data-crypto-price-container")
        /** @type {HTMLTemplateElement | undefined} */
        const template = document.querySelector(templateQuery)
        /** @type {HTMLDivElement | undefined} */
        const templateItem = template?.content.children[0]
        if (!templateItem) return

        let limit = container.getAttribute("data-crypto-price-limit")
        if (limit !== null) limit = parseNum(limit)

        container.innerHTML = ''

        cryptos.forEach((crypto, i) => {
            if (limit !== null && i + 1 > limit) return
            const priceData = totalPriceData[crypto.id]
            const price = priceData.usd
            const percentageDiff = priceData.usd_24h_change

            /** @type {HTMLDivElement} */
            const item = templateItem.cloneNode(true)

            if (percentageDiff >= 0) item.classList.add("positive")
            else item.classList.add("negative")

            item.querySelectorAll("[data-crypto-symbol]").forEach((el) => el.textContent = crypto.symbol)
            item.querySelectorAll("[data-crypto-name]").forEach((el) => el.textContent = crypto.name)
            item.querySelectorAll("[data-crypto-price]").forEach((el) => el.textContent = `$${formatNumber(price, 2, 2)}`)
            item.querySelectorAll("[data-crypto-price-percentage]").forEach((el) => el.textContent = `${percentageDiff >= 0 ? '+' : ''}${Intl.NumberFormat("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(percentageDiff)}%`)

            if (i === 0) container.appendChild(item)
            else container.appendChild(item.cloneNode(true))
        })
    })
}

export default cryptoPrices
